import { Table, Badge, Switch, Tag, message } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";

moment.locale("es");

export default function InspectorOverview(props) {
  const [inspectorVerifs, setInspectorVerifs] = useState(null);
  const { inspector } = props;

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/overview/${inspector.UsuarioID}`).then((res) => {
      setInspectorVerifs(res.data);
    });
  }, []);

  const formatCurrencyRight = (value) => {
    return (
      <div style={{ textAlign: "right" }}>
        {new Intl.NumberFormat("es-MX", {
          style: "currency",
          currency: "MXN",
        }).format(value)}
      </div>
    );
  };

  const handlePagoRecibidoChange = (value, VerificacionID) => {
    const requestData = {
      PagoRecibido: value ? 1 : 0,
      FechaPago: value ? moment().format("YYYY-MM-DD") : null,
    };

    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/pago/${VerificacionID}`, requestData)
      .then((response) => {
        message.success("Pago marcado como recibido exitosamente");
        axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/overview/${inspector.UsuarioID}`).then((res) => {
          setInspectorVerifs(res.data);
        });
      })
      .catch((error) => {
        message.error("Error marcando pago como recibido");
        console.error(error);
      });
  };

  const handlePapeleriaRecibidaChange = (value, VerificacionID) => {
    const requestData = {
      PapeleriaRecibida: value ? 1 : 0,
      FechaPapeleria: value ? moment().format("YYYY-MM-DD") : null,
    };

    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/papeleria/${VerificacionID}`, requestData)
      .then((response) => {
        message.success("Papeleria marcada como recibida exitosamente");
        axios.get(`${process.env.REACT_APP_API_URL}/verificaciones/overview/${inspector.UsuarioID}`).then((res) => {
          setInspectorVerifs(res.data);
        });
      })
      .catch((error) => {
        message.error("Error marcando papeleria como recibida");
        console.log(error);
      });
  };

  const columns = [
    {
      title: "Folio",
      dataIndex: "ControlInterno",
      key: "ControlInterno",
      render: (text, record) => <Link to={`/verificaciones/${record.VerificacionID}`}>{text}</Link>,
    },
    {
      title: "Verificador",
      dataIndex: "NombreCompleto",
      key: "NombreCompleto",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text) => {
        switch (text) {
          case 1:
            return (
              <>
                <Badge status="default" />
                En proceso
              </>
            );
          case 2:
            return (
              <>
                <Badge status="processing" />
                En revisión
              </>
            );
          case 3:
            return (
              <>
                <Badge status="warning" />
                Emitido
              </>
            );
          case 4:
            return (
              <>
                <Badge status="success" />
                Pagado
              </>
            );
          case 5:
            return (
              <>
                <Badge status="error" />
                Cancelado
              </>
            );
          default:
            return <span>Desconocido</span>; // default case if status doesn't match any of the above
        }
      },
    },
    {
      title: "Creada",
      dataIndex: "FechaCreacion",
      key: "FechaCreacion",
      render: (text) => {
        return text && text !== "0000-00-00" ? (
          <>
            <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
            <div>{moment(text, "YYYY-MM-DD").isSame(moment(), "day") ? "Hoy" : moment(text, "YYYY-MM-DD").fromNow()}</div>
          </>
        ) : (
          <Tag color="red">No disponible</Tag> // Show red Tag if null or "0000-00-00"
        );
      },
    },
    // {
    //   title: "A revisión",
    //   dataIndex: "FechaListo",
    //   key: "FechaListo",
    //   render: (text) => {
    //     return text && text !== "0000-00-00" ? (
    //       <>
    //         <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //         <div>{moment(text, "YYYY-MM-DD").isSame(moment(), "day") ? "Hoy" : moment(text, "YYYY-MM-DD").fromNow()}</div>
    //       </>
    //     ) : (
    //       <Tag color="red">No disponible</Tag> // Show red Tag if null or "0000-00-00"
    //     );
    //   },
    // },

    // {
    //   title: "Emitida",
    //   dataIndex: "FechaEmision",
    //   key: "FechaEmision",
    //   render: (text) => {
    //     return text && text !== "0000-00-00" ? (
    //       <>
    //         <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //         <div>{moment(text, "YYYY-MM-DD").isSame(moment(), "day") ? "Hoy" : moment(text, "YYYY-MM-DD").fromNow()}</div>
    //       </>
    //     ) : (
    //       <Tag color="red">No disponible</Tag> // Show red Tag if null or "0000-00-00"
    //     );
    //   },
    // },

    // {
    //   title: "Pagada",
    //   dataIndex: "FechaPago",
    //   key: "FechaPago",
    //   render: (text) => {
    //     return text && text !== "0000-00-00" ? (
    //       <>
    //         <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //         <div>{moment(text, "YYYY-MM-DD").isSame(moment(), "day") ? "Hoy" : moment(text, "YYYY-MM-DD").fromNow()}</div>
    //       </>
    //     ) : (
    //       <Tag color="red">No disponible</Tag> // Show red Tag if null or "0000-00-00"
    //     );
    //   },
    // },

    // {
    //   title: "Papelería",
    //   dataIndex: "FechaPapeleria",
    //   key: "FechaPapeleria",
    //   render: (text, record) => {
    //     // Check if FechaPapeleria is not null
    //     if (text && text !== "0000-00-00") {
    //       // If FechaEmision is available, calculate the deadline
    //       const deadline = record.FechaEmision ? moment(record.FechaEmision, "YYYY-MM-DD").add(4, "days") : null;

    //       // Check if the FechaPapeleria is before or after the deadline
    //       if (deadline) {
    //         const isDelayed = moment(text, "YYYY-MM-DD").isAfter(deadline);
    //         return (
    //           <>
    //             <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //             <div>{isDelayed ? "Retraso" : "OK"}</div>
    //           </>
    //         );
    //       }
    //       return (
    //         <>
    //           <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //           <div>Fecha de emisión no disponible</div>
    //         </>
    //       );
    //     }

    //     // If FechaPapeleria is null, show remaining days until the deadline
    //     if (record.FechaEmision) {
    //       const deadline = moment(record.FechaEmision, "YYYY-MM-DD").add(4, "days");
    //       const remainingDays = deadline.diff(moment(), "days");
    //       return (
    //         <>
    //           <Tag color="blue">Faltan {remainingDays} días</Tag>
    //         </>
    //       );
    //     }

    //     return <Tag color="red">No disponible</Tag>; // Default when FechaPapeleria is null and no FechaEmision
    //   },
    // },

    // {
    //   title: "Cancelada",
    //   dataIndex: "FechaCancelacion",
    //   key: "FechaCancelacion",
    //   render: (text) => {
    //     return text && text !== "0000-00-00" ? (
    //       <>
    //         <div>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</div>
    //         <div>{moment(text, "YYYY-MM-DD").isSame(moment(), "day") ? "Hoy" : moment(text, "YYYY-MM-DD").fromNow()}</div>
    //       </>
    //     ) : (
    //       <Tag color="red">No disponible</Tag> // Show red Tag if null or "0000-00-00"
    //     );
    //   },
    // },

    {
      title: "PagoRecibido",
      dataIndex: "PagoRecibido",
      key: "PagoRecibido",
      render: (text, record) => (
        <Switch checked={text === 1} onChange={(value) => handlePagoRecibidoChange(value, record.VerificacionID)} />
      ),
    },
    {
      title: "PapeleriaRecibida",
      dataIndex: "PapeleriaRecibida",
      key: "PapeleriaRecibida",
      render: (text, record) => (
        <Switch checked={text === 1} onChange={(value) => handlePapeleriaRecibidaChange(value, record.VerificacionID)} />
      ),
    },
    {
      title: "Monto",
      dataIndex: "Monto",
      key: "Monto",
      render: (text) => formatCurrencyRight(text),
    },
    {
      title: "ComisionVerificador",
      dataIndex: "ComisionVerificador",
      key: "ComisionVerificador",
      render: (text) => formatCurrencyRight(text),
    },
    {
      title: "ComisionUnidad",
      dataIndex: "ComisionUnidad",
      key: "ComisionUnidad",
      render: (text) => formatCurrencyRight(text),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={inspectorVerifs} size="small" />
    </>
  );
}
